import React from 'react';
import { Form } from '@duxton-web/ui';
import { useParams } from 'react-router-dom';

import {
  getAssignmentStrategy,
  isViewMode,
} from '@/features/experiment/constants';
import {
  useExperimentContext,
  useExperimentDispatchContext,
} from '@/features/experiment/contexts/experiment-context';
import { setSlottingByGroup } from '@/features/experiment/store/actions/experiment/action-creators';
import { Constraint } from '@/lib/PlannerDTOs';
import GroupSelector from '@/pages/ExperimentFormV2/common/GroupSelector';

const StaticTarget = () => {
  const params = useParams<{ action: string }>();
  const { action } = params;

  const experimentContext = useExperimentContext();
  const experimentDispatch = useExperimentDispatchContext();
  const { experiment, configurations } = experimentContext;
  const isAssignmentStrategySelected = !!getAssignmentStrategy(configurations);

  const disablePopulationStepContent =
    !isAssignmentStrategySelected || isViewMode(action);

  return (
    <Form.Item
      name={['experiment', 'byGroup']}
      style={{ marginBottom: 0 }}
      rules={[
        {
          required: true,
          message: '',
        },
      ]}
    >
      <GroupSelector
        disableInlineGroup
        mode={null}
        disabled={disablePopulationStepContent}
        constraint={experiment?.byGroup}
        onChange={(constraint: Constraint) => {
          experimentDispatch(setSlottingByGroup(constraint));
        }}
      />
    </Form.Item>
  );
};

export default StaticTarget;
